<!--
 * @Author: zhb 1822394027@qq.com
 * @Date: 2022-10-11 15:40:53
 * @LastEditors: zhb 1822394027@qq.com
 * @LastEditTime: 2022-10-17 18:15:37
 * @FilePath: \huayue\src\components\home-view-canvas.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <div>
    <img
      id="home-canvas6"
      :src="require('@/assets/home/home-canvas6.png')"
      alt=""
      style="display:none"
    />
    <canvas
      id="myCanvas"
      width="1200"
      height="666"
    >
    </canvas>
  </div>
</template>
<script>
export default {
  data () {
    return {
      ctx: null,
      arcy1: 90,
      arcX2: 600,
      arcX3: 1200,
      arcX4: 1200,
    };
  },
  mounted () {
    const c = document.getElementById('myCanvas');
    this.homeCavas6 = document.getElementById('home-canvas6');
    this.ctx = c.getContext('2d');
    this.draw({ type: 'down', });
  },
  methods: {
    draw ({ type, }) {
      this.ctx.clearRect(0, 0, 1199, 671);
      this.ctx.beginPath();
      this.ctx.globalCompositeOperation = 'source-over';
      this.ctx.drawImage(this.homeCavas6, this.arcX2, Math.abs((0.3 * this.arcX2) - 180));
      this.ctx.drawImage(this.homeCavas6, this.arcX3, 400 - (this.arcX3 === 1200 ? this.arcX3 : 0.3 * this.arcX3) - 40);
      this.ctx.drawImage(this.homeCavas6, this.arcX4, 600 - (this.arcX4 === 1200 ? this.arcX4 : 0.3 * this.arcX4) - 40);
      this.ctx.stroke();
      if (this.arcX2 <= -40) {
        this.arcX2 = 600;
      } else {
        this.arcX2 -= 4;
      }
      if (this.arcX3 <= -40) {
        this.arcX3 = 1200;
      } else {
        this.arcX3 -= 4;
      }
      if (this.arcX4 <= -40) {
        this.arcX4 = 1200;
      } else {
        this.arcX4 -= 5;
      }
      if (this.arcy1 === 70) {
        this.arcy1 += 0.5;
        window.requestAnimationFrame(this.draw.bind(this, { type: 'up', }));
      } else if (this.arcy1 === 90) {
        this.arcy1 -= 0.5;
        window.requestAnimationFrame(this.draw.bind(this, { type: 'down', }));
      } else {
        if (type === 'up') {
          this.arcy1 += 0.5;
          window.requestAnimationFrame(this.draw.bind(this, { type: 'up', }));
        } else {
          this.arcy1 -= 0.5;
          window.requestAnimationFrame(this.draw.bind(this, { type: 'down', }));
        }
      }
    },
    clear() {
      // context.clearRect(0, 0, canvas.width, canvas.height);
    },
  },
};
</script>
<style lang="scss" scoped>
</style>
